import request from "../../utils/request";
import { ScheduledShiftInput, ScheduledShiftView } from "../../models/attendance";
import { Result } from "../../models/general";

export async function anyUserWithVariableScheduleRule() {
  const response = await request.get<Result<boolean>>(`shift/AnyUserWithVariableScheduleRule`);
  return response.data;
}

export async function setScheduledShift(details: ScheduledShiftInput) {
  const response = await request.post<Result<ScheduledShiftView>>(`shift/SetScheduledShift`, details);
  return response.data;
}

export async function getScheduledShift(from: string, to: string) {
  const response = await request.get<Result<ScheduledShiftView[]>>(`shift/GetScheduledShifts/${from}/${to}`);
  return response.data;
}

export async function removeScheduledShift(id: number) {
  const response = await request.delete<Result<{}>>(`shift/${id}`);
  return response.data;
}

// Override endpoints (manual per-occurrence overrides)
export async function createShiftOverride(details: ScheduledShiftInput) {
  const response = await request.post<Result<ScheduledShiftView>>(`shift/Override`, details);
  return response.data;
}

export async function deleteShiftOverride(id: number) {
  const response = await request.delete<Result<{}>>(`shift/Override/${id}`);
  return response.data;
}

// RRULE weekly subset preview (server validates and expands occurrences)
export async function previewRRule(payload: { rrule: string; startDateUtc?: string; endDateUtc?: string; startTimeOfDayMinutes?: number; endTimeOfDayMinutes?: number; timeZoneId?: string; }) {
  const response = await request.post<Result<{ occurrences: string[] }>>(`shift/RRule/Preview`, payload);
  return response.data;
}

// Shift Sets list (id, name)
export interface ShiftSetView { id: string | number; name: string; }
export async function getShiftSets() {
  const response = await request.get<Result<ShiftSetView[]>>(`shift/ShiftSets`);
  return response.data;
}